import { adaptPersona } from 'actions/mapping.typed'
import { teamApi, teamHooks } from 'features/team'
import { useMemo } from 'react'

export function useLegacyPersonas() {
	const showMembers = teamHooks.useIsEnable()
	const query = teamApi.usePersonasQuery(undefined, {
		skip: !showMembers
	})

	const personas = useMemo(
		() => (query.data?.documents || []).map(adaptPersona),
		[query.data]
	)

	return [personas, query] as const
}
